import { render, staticRenderFns } from "./sitefooter.vue?vue&type=template&id=c291f8cc&scoped=true"
import script from "./sitefooter.vue?vue&type=script&lang=js"
export * from "./sitefooter.vue?vue&type=script&lang=js"
import style0 from "./sitefooter.vue?vue&type=style&index=0&id=c291f8cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c291f8cc",
  null
  
)

export default component.exports